import React, { Component } from 'react';
import './css/homepage.css';
import Loading from './loading';
import TriviaPanel from './triviaPanel';
import RankingPanel from './rankingPanel';
import GameResult from './gameResult';
import usernames from './constants/usernames';
import {categoriesPic, categoriesText} from './constants/categories';
import baseUrl from './constants/config'
import FeedbackModal from './feedbackModal';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Checkbox from 'rc-checkbox';
import ReactGA from 'react-ga';

class Homepage extends Component {
  constructor (props) {
    super(props)
    this.fetchQuestion = this.fetchQuestion.bind(this)
    this.startGame = this.startGame.bind(this)
    this.handleQuestionFinished = this.handleQuestionFinished.bind(this)
    this.submitAnswer = this.submitAnswer.bind(this)
    this.skipQuestion = this.skipQuestion.bind(this)
    this.triviaPanel = React.createRef();
    this.ping = this.ping.bind(this)
    this.showRankingEvent = this.showRankingEvent.bind(this)
    this.createNewGame = this.createNewGame.bind(this)
    this.getInitialState = this.getInitialState.bind(this)
    this.setInitialState = this.setInitialState.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.feedbackModal = React.createRef();
    this.state = this.getInitialState()

    this.state.categoriesPic = new Array(categoriesPic.length).fill(true);
    this.state.categoriesText = new Array(categoriesText.length).fill(true);

    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  getInitialState() {
    var randomUser = usernames[Math.floor(Math.random()*usernames.length)];
    return {
      hasStarted: false,
      isRoomLoaded: false,
      isCreatingRoom: false,
      isFinalState: false,
      userId: randomUser,
      userIdInput: '',
      roomId: '',
      questionList: [],
      answerChoices: [],
      score: 0,
      numCorrect: 0,
      avgScore: 0,
      rank: 'N/A',
      showRanking: false,
      rankingList: [],
      questionNumber: 1,
      showIncorrectAnswer: false,
      isCorrectAnswer: false
    }
  }

  setInitialState() {
    var initialState = this.getInitialState()
    this.setState(initialState)
  }

  handleErrors(response) {
    if (!response.ok) {
      console.log('Something possibly went wrong. Please refresh the page.')
    }
    return response;
  }

  createNewGame() {
    var randomUser = (this.state.userIdInput === "") ? this.state.userId : this.state.userIdInput
    
    this.setState({userId: randomUser, isCreatingRoom: true, userIdInput: randomUser})
    var filter = this.props.filter ? this.props.filter : null
    console.log(filter)

    var categories = this.props.categoryPrefix
    if (this.state.categoriesPic.every(x => x) && this.state.categoriesText.every(x => x)) {

    } else {
      var selected = []
      for (var i = 0; i < this.state.categoriesPic.length; i++) {
        if (this.state.categoriesPic[i]) {
          selected.push(categoriesPic[i][0])
        }
      }
      for (var i = 0; i < this.state.categoriesText.length; i++) {
        if (this.state.categoriesText[i]) {
          selected.push(categoriesText[i][0])
        }
      }
      if (selected.length > 0) {
        categories = selected
      }
    }
    console.log(categories)

    fetch(baseUrl + 'room/api/createRoom', { 
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: randomUser,
          category: categories,
          filters: filter
        })
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
       this.setState({ isRoomLoaded: true, roomId: data['roomId']})
      });
  }

  startGame() {
    if (this.state.roomId === '') {
      return;
    }

    fetch(baseUrl + 'trivia/api/startFgo', { 
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roomId: this.state.roomId,
          userId: this.state.userId
        })
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
      });

      this.fetchQuestion()
  }

  showRankingEvent() {
    fetch(baseUrl + 'trivia/api/getTopPlayers?triviaCategoryPrefix=' + this.props.categoryPrefix, { 
        method: 'GET'
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
        this.setState({ showRanking: true, rankingList: data['top']})
      });
  }

  ping() {
    if (this.state.roomId === '') {
      return;
    }

    fetch(baseUrl + 'trivia/api/ping', { 
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roomId: this.state.roomId
        })
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
      });
  }

  fetchQuestion () {
    if (this.state.roomId === '') {
      return;
    }
    this.setState({isCorrectAnswer: false})
    fetch(baseUrl + 'trivia/api/getQuestion?roomId=' + this.state.roomId, { 
        method: 'GET'
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
        if (data['contentList'].length === 0) {
          this.setState({isFinalState: true})
          this.showRankingEvent()
          return
        }
        var questionNumber = data['currentQuestion']
        this.setState({ 
          hasStarted: true, 
          questionList: data['contentList'],
          answerChoices: data['choices'],
          questionNumber: questionNumber
        })
      });
  }

  handleQuestionFinished() {
    this.setState({showIncorrectAnswer: false});
    fetch(baseUrl + 'trivia/api/getAnswer?roomId=' + this.state.roomId, { 
        method: 'GET'
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
        this.triviaPanel.current.showAnswer(data['answer']);
      });

    fetch(baseUrl + 'trivia/api/getGameState?roomId=' + this.state.roomId, { 
        method: 'GET'
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
        if (data['gameState'] === 'checkAnswer') {
          this.triviaPanel.current.startAnswerDisplayTimer(data['gameStateDuration']);
        }
        var score = data['scoreBoard'][0]['score']
        var numCorrect = data['scoreBoard'][0]['numCorrect']
        var avgScore = data['scoreBoard'][0]['avgScore']
        var rank = data['scoreBoard'][0]['ranking']
        var totalRank = data['scoreBoard'][0]['totalRanked']
        var rankString = 'N/A'
        if (rank && totalRank) {
          rankString = rank + ' out of ' + totalRank
        }
        this.setState({score: score, avgScore: avgScore, rank: rankString, numCorrect: numCorrect})
      });
  }

  submitAnswer(answer) {
    this.setState({showIncorrectAnswer: false});
    fetch(baseUrl + 'trivia/api/submitAnswer', { 
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roomId: this.state.roomId,
          userId: this.state.userId,
          answer: answer
        })
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
        if (data['isMultipleChoice']) {
          if (data['isCorrect']) {
            this.setState({isCorrectAnswer: true});
          } else {
            this.triviaPanel.current.skipQuestion()
          }
          return
        }
        if (data['isCorrect']) {
          this.setState({isCorrectAnswer: true});
        } else {
          this.setState({showIncorrectAnswer: true});
        }
      });
  }

  skipQuestion() {
    fetch(baseUrl + 'trivia/api/skipQuestion', { 
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roomId: this.state.roomId
        })
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
        this.handleQuestionFinished()
      });
  }

  renderCategoryPicker() {
    const categoryPicComponents = categoriesPic.map((categoryInfo, i) =>
      (
        <div className="checkBoxRow">
          <div className="checkBoxText">
            <Checkbox 
              key = {i}
              checked = {this.state.categoriesPic[i] ? 1 :0}
              disabled={false}
              onChange={() => {
                  var newState = this.state.categoriesPic
                  newState[i] = !newState[i]
                  this.setState({categoriesPic: newState})
                }
              }
            />
            {categoryInfo[1]}
          </div>
          <div className="questionPickerImageWrapper">
                <img className="questionPickerImage"
                  src={categoryInfo[2]} 
                  alt={categoryInfo[3]}/>
          </div>
        </div>
      )
    );
    function getContents(contentList) {
      return (
        contentList.map((content, j) =>
          <div>
              {content}
          </div>
        )
      )
    }

    const categoryTextComponents = categoriesText.map((categoryInfo, i) =>
      (
        <div className="checkBoxRow">
          <div className="checkBoxText">
            <Checkbox 
              key = {i}
              checked = {this.state.categoriesText[i] ? 1 :0}
              disabled={false}
              onChange={() => {
                  var newState = this.state.categoriesText
                  newState[i] = !newState[i]
                  this.setState({categoriesText: newState})
                }
              }
            />
            {categoryInfo[1]}
          </div>
          <div className="questionPickerImageWrapper">
            {getContents(categoryInfo[2])}
          </div>
        </div>
      )
    );
    return (
      <ul className="questionPicker">
        {categoryPicComponents}
        {categoryTextComponents}
      </ul>
    );
  }

  render() {
    const hasStarted = this.state.hasStarted;
    const isRoomLoaded = this.state.isRoomLoaded;
    const questionList = this.state.questionList;
    const shouldShowRanking = false && this.state.showRanking && 
      this.state.categoriesText.every(x => x) && this.state.categoriesPic.every(x => x);
    const shouldShowRankingButton = false && this.state.categoriesPic.every(x => x) && 
      this.state.categoriesText.every(x => x) && !shouldShowRanking && !hasStarted;

    return (
      <div className="Homepage">
        <header className="Homepage-header">
          {this.props.title && <title>{this.props.title}</title>}
          {this.props.description && <meta NAME="Description" CONTENT={this.props.description}/>}
          <h1 className="Homepage-title" 
          onClick={this.setInitialState}>{this.props.banner}</h1>
        </header>

        {!hasStarted &&        
          <div className="Homgpage-intro-box">
            <form className="userIdForm" onSubmit={(event) => {event.preventDefault();}}>
              User ID:
              < input type="text" 
                placeholder = {this.state.userId}
                className = "Text-Input"
                value={this.state.userIdInput}
                onChange={evt => this.setState({userIdInput: evt.target.value})}/>
              {!this.state.isCreatingRoom &&
                <button className="Answer-Submit-Btn" type = "submit"
                  disabled={this.state.isCreatingRoom}
                  onClick={this.createNewGame}>
                  Create Room
                </button>
              }
            </form>

            {isRoomLoaded && !hasStarted && 
              <button className="Homepage-button" onClick={this.startGame}>
                <span>Start Game</span>
              </button>
            }

            <p className="Homepage-intro">
              { this.props.introText }
            </p>
            { this.props.link && 
              <p className="Homepage-intro">
                <Link to="/">Too easy? Try all questions!</Link>
              </p>
            }
            <p className="Homepage-intro">
              Pick the question categories you want in the quiz. 
            </p>

            <p className="Homepage-intro">
              Some questions require sound.
            </p>

            {
              !this.state.isCreatingRoom &&
              <div>
                <button className="radioSelectBtn" type = "submit"
                    onClick={ () => {
                      var ct = new Array(categoriesText.length).fill(true)
                      var cp = new Array(categoriesPic.length).fill(true)
                      this.setState({categoriesText: ct, categoriesPic: cp})
                    }}>
                    Select all
                </button>
                <button className="radioSelectBtn" type = "submit"
                    onClick={ () => {
                      var ct = new Array(categoriesText.length).fill(false)
                      var cp = new Array(categoriesPic.length).fill(false)
                      this.setState({categoriesText: ct, categoriesPic: cp})
                    }}>
                    Unselect all
                </button>
              </div>
            }

            { this.renderCategoryPicker() }
          </div>
        }

        {!isRoomLoaded && this.state.isCreatingRoom &&
          <Loading></Loading>
        }

        {shouldShowRankingButton &&
          <button className="Homepage-button" onClick={this.showRankingEvent}>
            <span>Rankings</span>
          </button>
        }
        {!hasStarted &&
          <FeedbackModal
              openAction = {() => {}}
            />
        }
        {shouldShowRanking && !hasStarted &&
          <RankingPanel rankingList = {this.state.rankingList}></RankingPanel>
        }

        {hasStarted && !this.state.isFinalState &&
          <TriviaPanel questionList = {questionList} 
            onQuestionFinished = {this.handleQuestionFinished}
            ref = {this.triviaPanel}
            onAnswerFinished = {this.fetchQuestion}
            onAnswerSubmit = {this.submitAnswer}
            onSkipQuestion = {this.skipQuestion}
            userId = {this.state.userId}
            roomId = {this.state.roomId}
            score = {this.state.score}
            numCorrect = {this.state.numCorrect}
            avgScore = {this.state.avgScore}
            rank = {this.state.rank}
            questionNumber = {this.state.questionNumber}
            showIncorrectAnswer = {this.state.showIncorrectAnswer}
            isCorrectAnswer = {this.state.isCorrectAnswer}
            answerChoices = {this.state.answerChoices}>
          </TriviaPanel>
        }

        {this.state.isFinalState &&
          <div>
            <p>You got {this.state.numCorrect} out of {this.state.questionNumber} correct</p>
            <p>Your Average Score: {this.state.avgScore.toFixed(2)}</p>
          </div>
        }
        {this.state.isFinalState && shouldShowRanking &&
          <div>
            <p>Ranking: {this.state.rank}</p>
            <h1>Leaderboard</h1>
            <GameResult rankingList = {this.state.rankingList}></GameResult>
          </div>
        }

      </div>
    );
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/homepage.js